import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const PROXY = process.env.REACT_APP_API_URL + "api/general/";

// Async thunk to fetch columns data
export const fetchColumns = createAsyncThunk("columns/fetchColumns", async (queryParams, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${PROXY}getTableColumns?page=${queryParams ? `${queryParams}` : ""}`);
    return response.data.result;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to fetch columns");
  }
}
);

const columnsSlice = createSlice({
  name: "columns",
  initialState: {
    columnsData: [],
    columnLoading: true,
    columnsError: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchColumns.pending, (state) => {
        state.columnLoading = true;
        state.columnsError = null;
        // never keep the previous page's columns while the new page's columns load
        state.columnsData = [];
      })
      .addCase(fetchColumns.fulfilled, (state, action) => {
        state.columnLoading = false;
        state.columnsData = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchColumns.rejected, (state, action) => {
        state.columnLoading = false;
        state.columnsError = action.payload;
      });
  }
});

export default columnsSlice.reducer;
